import {
    AppInstallationSubscription,
    GetAllAppSubscriptionsResponse,
} from 'hooks/shopify/queries/get-all-app-subscriptions.graphql';
import { SubscriptionStatus } from 'models/SubscriptionStatus';

export const getCurrentSubscription = (
    currentAppInstallation: GetAllAppSubscriptionsResponse['currentAppInstallation'] | undefined
): AppInstallationSubscription | undefined => {
    const activeSubscriptions = currentAppInstallation?.activeSubscriptions;
    if (activeSubscriptions?.length > 0) return activeSubscriptions[0];
    return currentAppInstallation?.allSubscriptions?.nodes?.find((s) => s.status === SubscriptionStatus.CANCELLED);
};
